import { useAuth0 } from "@auth0/auth0-react";
import { hasOrganizationUserId, roleMatch } from "actions/auth";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { UserRoles } from "types/enums";
import PageNotFound from "./PageNotFound";

export function RequireAuth({ children, roles }) {
  const location = useLocation();
  const account = useSelector((state) => state.account);
  const { isAuthenticated, isLoading, logout } = useAuth0();
  const redirectPath = { redirect: location.pathname + location.search };
  const isPortalUser = isAuthenticated
    ? roleMatch([UserRoles.PortalUser])
    : false;
  if (isLoading || (account.isLoading && isAuthenticated)) {
    return <></>;
  }
  if (account && !account.isLoading && !account.isActive) {
    logout({ logoutParams: { returnTo: window.location.origin } });
  }

  if (
    account &&
    !account.isLoading &&
    !account.hasAcceptedTermsOfUse &&
    !account.isInternal
  ) {
    const registrationLink = `/register/${account.registrationGuid}`;
    return (
      <Navigate to={registrationLink} state={{ from: location }} replace />
    );
  }

  if (
    account &&
    !account.isLoading &&
    account.hasAcceptedTermsOfUse &&
    !account.isInternal &&
    account.isBillingInApp &&
    !account.stripeId
  ) {
    return <Navigate to="/billing" state={{ from: location }} replace />;
  }

  if (
    isAuthenticated &&
    !isPortalUser &&
    roles === undefined &&
    hasOrganizationUserId()
  ) {
    return children;
  }

  if (
    isAuthenticated &&
    !isPortalUser &&
    roleMatch(roles) &&
    hasOrganizationUserId()
  ) {
    return children;
  }

  if (
    isAuthenticated &&
    !isPortalUser &&
    !roleMatch(roles) &&
    hasOrganizationUserId()
  ) {
    return <PageNotFound />;
  }

  if (isAuthenticated && !hasOrganizationUserId()) {
    return (
      <Navigate
        to={
          isPortalUser
            ? "/wyloo"
            : {
                pathname: "/organizations",
                search: `?${queryString.stringify(redirectPath)}`,
              }
        }
        state={{ from: location }}
        replace
      />
    );
  }
  return (
    <Navigate
      to={
        isPortalUser
          ? "/wyloo"
          : {
              pathname: "/authorize",
              search: `?${queryString.stringify(redirectPath)}`,
            }
      }
      state={{ from: location }}
      replace
    />
  );
}
